import React , { useEffect , useState  }  from 'react';
import './gamedetail.css';
import { useParams } from "react-router-dom";
import ios from '../../assets/ios.svg';
import android from '../../assets/android.svg';
import fallbackone from '../../assets/fallbackone.jpg';


import DataService from "../../data.service";
 import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import { Link } from 'react-router-dom';




// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import "swiper/css/pagination";

                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     import { FreeMode, Thumbs , Pagination} from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay,Navigation} from 'swiper';
SwiperCore.use([Autoplay,Navigation]);



function GamedetailComponent(){
  const [gameData, setGameData] = useState([]);
  const [newgameData, setNewGameData] = useState([]);
  const [screenShot, setScreenShot] = useState([]);
  const [screenShotNumber, setScreenShotNumber] = useState(0);
  const [screenshotImages , setScreenshotImages ] = useState([])
  const [isOpen, setIsOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [imgg, setImg] = useState(null);
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const { id } = useParams();
  useEffect(() => {
    DataService.get(id).then(response => {
      setGameData(response.data);
    }).catch(e => {
      console.log(e);
    });
    
    DataService.getAll().then(response => {
      setNewGameData(response.data.results);
    }).catch(e => {
      console.log(e);
    });

    DataService.getScreenshot(id).then(response => {
      setScreenShot(response.data.results);
      response.data.results.forEach(
          d =>  setScreenshotImages(screenshotImages => [...screenshotImages,d.image])
      );
      setScreenShotNumber(response.data.count)
    }).catch(e => {
        console.log(e);
    });     
  }, [id]);
    
  const clickMe = (img) =>{
      setIsOpen(true)
      setImg(img)
  }
  return (
    <>

    {isOpen && (
      <Lightbox
           mainSrc={screenshotImages[photoIndex]}
           nextSrc={screenshotImages[(photoIndex + 1) % screenshotImages.length]}
           prevSrc={screenshotImages[(photoIndex + screenshotImages.length - 1) % screenshotImages.length]}
           onCloseRequest={() => setIsOpen(false)}
           onMovePrevRequest={() =>
               setPhotoIndex( (photoIndex + screenshotImages.length - 1) % screenshotImages.length)
           }
           onMoveNextRequest={() =>
               setPhotoIndex( (photoIndex + 1) % screenshotImages.length)
           }
      />
    )}

    <div className='page gameDetail gameDetailImg p-0'> 
            <div className='gameDetailSection'>
              <div className="container">
                <div className="row">
                  <div className="col-lg-8 col-12 detail">


                  <Swiper style={{ "--swiper-navigation-color": "#fff", "--swiper-pagination-color": "#fff", }}
        loop={true}
        spaceBetween={10}
        navigation={true}
        thumbs={{ swiper: thumbsSwiper }}
        modules={[FreeMode, Navigation, Thumbs]}
        className="mySwiper2"
      >
        <SwiperSlide>
            <div className="video-container">
                <iframe src={`https://www.youtube.com/embed/${gameData.youtube}`} frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
            </div>
          </SwiperSlide>
          {screenShot.map((item, i) => (
                <SwiperSlide key={i}  >
                  <img src={item.image} className='w-100 imagePopup'  alt='SliderImage' />
                </SwiperSlide>
          ))}
        </Swiper>
        <Swiper onSwiper={setThumbsSwiper} loop={true}  spaceBetween={10}slidesPerView={5}  freeMode={true}  watchSlidesProgress={true} modules={[FreeMode, Navigation, Thumbs]} className="mySwiper thumb">
          <SwiperSlide>
          <img src={`https://img.youtube.com/vi/${gameData.youtube}/0.jpg`} className='w-100 imagePopup' />
          </SwiperSlide>
          {screenShot.map((item, i) => (
            <SwiperSlide key={i}  >
              <img src={item.image} className='w-100 imagePopup'  alt='SliderImage' />
            </SwiperSlide>
          ))}
      </Swiper>



                  </div>
                  <div className="col-lg-4 col-12">
                    <div className="gamedetailBox">
                        <h3 className='gameDetailHeading'>{gameData.name}</h3>
                        <div className='gridContent'>{gameData.description}</div>
                        <a  target="_blank" href="https://pandamaster.vip:8888/index.html"><button className="gameDetaildownloadBtn">Download</button></a>

                        <div className="row gamedetailTwoCol">
                          <div className="col-lg-6 gamedetailleftSpan">Platform</div>
                          <div className="col-lg-6 gamedetailRightSpan">
                            <img src={ios} style={{filter: 'invert()'}}/>
                            <img src={android} style={{filter: 'invert()'}}/>
                          </div>
                        </div>
                    </div>
                    
                  </div>
                </div>
          

            
      
                {/* <div className='gameDetailBox'>
                    
                    <div className="row">
                        <div className="col-lg-6 col-sm-6 col-12">
                            <h3 className='gameDetailHeading'>{gameData.name}</h3>
                            <div className='gridContent'>{gameData.description}</div>
                        </div>
                        <div  className="col-lg-6 col-sm-6 col-12">
                            <img src={gameData.image} className='GameDataImage' alt={gameData.name} />
                        </div>
                    </div>
                  
                </div> */}
              </div>
            </div>
            <div className="similarGameSection">
              <div className="container">
                  
                  <div className="row  m-0 p-0">
                     <div className="col-lg-9 col-12 p-0">
                        <div className='row'>
                            <div className='col-12'>
                              <h3 className='similarTitle'>Similar Games</h3>
                            </div>
                        </div>
                        {newgameData.slice(0, 4).map((item, i) => (
                           <Link className="" key={i}  to={`/gamedetail/${item.id}`}>
                              <div className="similargamesBox">
                                    <div className="row m-0 p-0">
                                      <div className="col-lg-5 col-12 m-0 p-0">
                                        <img src={item.image} className='w-100' style={{ borderTopLeftRadius: 3}}  alt='SliderImage' />


                                      </div>
                                      <div className="col-lg-7 col-12 similargamesRightBox">
                                        <h3 className='similargamesRightBoxTitle'>{item.name}<span> {item.game_type === 1 ? ('Fish' ) : ('')}
                                          {item.game_type === 2 ? ('Slot' ) : ('')}
                                          {item.game_type === 3 ? ('Keno' ) : ('')}
                                          {item.game_type === 4 ? ('Other' ) : ('')} </span></h3>
                                        <div className='similargamesRightBoxDescription'>{item.description}</div>
                                      </div>
                                    </div>
                                    <div className="row m-0 gameboxBottom">
                                      <div className="col-12">
                                        <a  target="_blank" href="https://pandamaster.vip:8888/index.html"><button className='gameBoxdownloadBtn'>Download</button></a>

                                      </div>
                                    </div>
                              </div>
                            </Link>
                        ))}

                     </div>
                     <div className="col-lg-3 col-12">
                        <div className='row'>
                            <div className='col-12'>
                                <h3 className="similarTitle">Popular Games</h3>
                            </div>
                        </div>

                        <Swiper direction={"vertical"}   breakpoints={{
                              "640": { "slidesPerView": 2 }, 
                              "768": { "slidesPerView": 3 }, 
                              "1024": { "slidesPerView": 4 }  }}
                              autoplay={{"delay": 2500,"disableOnInteraction": false }}  loop={true}  slidesPerView={1} spaceBetween={10}  className="verticalSlider recommendedSlider">
                            {newgameData.slice(0, 10).map((item, i) => (
                                <SwiperSlide>
                                    <Link className="" key={i}  to={`/gamedetail/${item.id}`}>
                                        <div className="homepageLatestCard">
                                            {item.image ? (<img src={item.image} alt="Game_Image" className='w-100'  /> ) : (<img src={fallbackone} alt="Lorem" className='w-100' />)}                      
                                            <div className='homepageLatestCardContent'>
                                                <div>
                                                  <h4 className='title'>{item.name}</h4>                                       
                                                </div>
                                                <div>
                                                  <button className='joinnowBtn'>Join Now</button>
                                                </div>
                                            </div>
                                        </div>
                                    </Link>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                        {/* {newgameData.slice(0, 4).map((item, i) => (
                            <Link className="" key={i}  to={`/gamedetail/${item.id}`}>
                                  <div className="homepageLatestCard">
                                      {item.image ? (<img src={item.image} alt="Game_Image" className='w-100'  /> ) : (<img src={fallbackone} alt="Lorem" className='w-100' />)}                      
                                      <div className='homepageLatestCardContent'>
                                        <div>
                                            <h4 className='title'>{item.name}</h4>
                                           
                                        </div>
                                        <div><button className='joinnowBtn'>Join Now</button></div>
                                      </div>
                                  </div>
                            </Link>
                        ))}  */}
                     </div>
                  
                  </div>

              </div>  
            </div>
                         
        </div>
     
    </>
  );

};



export default GamedetailComponent;